import { render, staticRenderFns } from "./Zoom.vue?vue&type=template&id=a77efe12"
import script from "./Zoom.vue?vue&type=script&lang=js"
export * from "./Zoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a77efe12')) {
      api.createRecord('a77efe12', component.options)
    } else {
      api.reload('a77efe12', component.options)
    }
    module.hot.accept("./Zoom.vue?vue&type=template&id=a77efe12", function () {
      api.rerender('a77efe12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Zoom.vue"
export default component.exports